import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './messages.scss';
import { t } from '../../services/i18nService';
import viewReadyTracker from '../../services/ViewReadyTracker';

import Message from './Message';
import ExitButton from './ExitButton';

class Messages extends React.PureComponent {
    static propTypes = {
        messages: PropTypes.array,
    };

    componentDidMount() {
        viewReadyTracker.getReporter()(true);
    }

    render() {
        const messages = this.props.messages;
        return (
            <div >
                <ExitButton />
                <div className={styles.messagesWrapper}>
                    <h1 className={styles.header}>
                        {t('messages.header')}
                    </h1>
                    <div className={styles.messages}>
                        {
                            messages
                                .sort((a, b) => {
                                    return new Date(b.timestamp) - new Date(a.timestamp);
                                })
                                .map((message) => {
                                    return <Message model={message} showClose={false} key={message.id} />;
                                })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const messages = state.messages.items;
    return {
        messages,
    };
}

const MessagesContainer = connect(mapStateToProps)(Messages);
export default MessagesContainer;
